<template>
    <div>
        <input type="file" :id="this.label" ref="iccFileInput" @change="uploadImage" style="display:none;"/>
        <label class="btn btn-sm btn-info" :for="this.label">{{ this.inputTitle }}</label>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'IccUpload',
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        inputTitle () {
            return this.label.includes('rs1') ? 'RS1 icc profile upload' : 'DS820 icc profile upload';
        }
    },
    methods: {
        async uploadImage() {
            if (this.$refs.iccFileInput.files.length > 0) {
                const file = this.$refs.iccFileInput.files[0];
                const formData = new FormData();
                formData.append('file', file);
                try {
                    const { data } = await Vue.axios.post('/filestorage', formData);
                    const filename = data.file.split('/').at(-1);
                    this.$emit('update:value', filename);
                } catch (e) {
                    console.error(e.message);
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
